<template>
    <div class="person-container">
        <div class="person-top">
            <img src="@/assets/img/person/person.png" alt="">
            <div class="person-info">
                    <img :src="info.user_avatar" alt="">
                    <div class="person-name">{{info.user_nickname}}</div>
                    <!-- <div class="person-phone">152XXXXXXXX</div> -->
            </div>
        </div>
        <div class="person-center">
            <div class="person-inter">
                <div class="person-integral">
                    <div class="integral-count">{{info.user_point}}</div>
                    <div >我的积分</div>
                </div>
                <div class="person-integral" @click="goIntegral">
                    <img src="@/assets/img/person/jifenshangcheng.png" alt="">
                    <div >积分商城</div>
                </div>
            </div>
        </div>
        <div class="person-equity">
            <div class="equity-item"  @click="goNextNav(item)" v-for="item in equityList" :key="item.id">
               <div class="item-left">
                    <img :src="item.img" alt="">
                    <span class="name">{{item.name}}</span>
               </div>
               <img src="@/assets/img/person/more.png" alt="" class="more">
            </div>
        </div>
    </div>
</template>
<script>
import  {apiInfo} from "@api"
export default {
    data(){
        return{
            equityList:[
                // {id:1,name:'我的兑换',url:'',img:require("@/assets/img/person/wodeduihuan.png")},
                {id:2,name:'我的订单',url:'MyOrders',img:require("@/assets/img/person/order.png")},
                // {id:3,name:'我的收藏',url:'',img:require("@/assets/img/person/shoucang.png")},
                // {id:4,name:'我的地址',url:'',img:require("@/assets/img/person/dizhi.png")},
                // {id:5,name:'我的消息',url:'',img:require("@/assets/img/person/duihua.png")},
            ],
            info:{}
        }
    },
    created(){
        this.apiInfo()
    },
    methods:{
        async apiInfo(){
            const [err,data] = await apiInfo()
            if(err) return console.warn(err)
            this.info = data
        },
        goIntegral(){
            this.$toast({
            message: '敬请期待',
            });
        },
        goNextNav(item){
            this.$router.push({
                name:item.url,
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .person-container{
        width: 100%;
        background:#fff;
        .person-top{
            width: 100%;
            height:333px;
            position: relative;
            img{
                width:100%;
                height: 100%;
            }
            .person-info{
                width: 100%;
                text-align: center;
                position: absolute;
                bottom: 18px;
                font-size:32px;
                font-family:PingFang SC;
                font-weight:bold;
                color:rgba(136,136,136,1);
                img{
                    width: 125px;
                    height: 125px;
                    border-radius: 50%;
                    margin-bottom: 20px;
                }
                .person-name{
                    margin-bottom: 23px;
                }
            }
        }
        .person-center{
            padding: 0 24px;
            margin-top: 10px;
            .person-inter{
                width:702px;
                height:98px;
                padding: 42px 0;
                margin:0 atuo;
                background:rgba(255,255,255,1);
                box-shadow:0px 5px 12px 1px rgba(222,71,66,0.41);
                border-radius:20px;
                display: flex;
                align-items: center;
                .person-integral{
                    width: 50%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: space-between;
                    font-size:34px;
                    font-family:PingFang SC;
                    font-weight:400;
                    color:rgba(102,102,102,1);
                    .integral-count{
                        font-size:50px;
                        font-family:PingFang SC;
                        font-weight:bold;
                        color:rgba(255,144,0,1);
                    }
                    img{
                        width: 60px;
                        height: 50px;
                    }
                }
            }
          
            
        }
        .person-equity{
            padding:0 24px;
            padding-top:70px;
        }
        .equity-item{
            display: flex;
            justify-content: space-between;
            margin-bottom: 54px;
            align-items: center;
            .item-left{
                font-size:28px;
                font-family:PingFang SC;
                font-weight:400;
                color:rgba(102,102,102,1);
                display: flex;
                align-items: center;
                img{
                    width: 40px;
                    height: 40px;
                    margin-right: 30px;

                }
            }
            .more{
                width: 23px;
                height: 23px;
            }
            
        }
    }
</style>